var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"IndexCarouselContainer"}},[_c('el-carousel',{attrs:{"indicator-position":"outside"}},_vm._l((this.imgUrls),function(item){return _c('el-carousel-item',{key:item},[_c('img',{staticClass:"el-carousel-item-img",attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }